import * as types from './actionTypes';  
import sendBrokerDealerApi from '../api/sendBrokerDealerApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doSendBrokerDealer(request) {

  return {
    type: types.DO_SEND_BROKERDEALER, 
    request
  };
}

export function doSendBrokerDealerRes(data) {  
  return {
    type: types.DO_SEND_BROKERDEALER_RES, 
    data
  };
}
export function sendBrokerDealer(request) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      sendBrokerDealerApi.doSendBrokerDealer(request).then(data => {
        if (data.error === 0) {
          dispatch(doSendBrokerDealerRes(data));
          dispatch(doSendBrokerDealerRes(null));
        }
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}